<template>
 <div>
    <el-tabs :tab-position="tabPosition"  v-model='type'>
      <el-tab-pane label="落地页信息" name="page">

        <el-dialog title="信息" :visible.sync="dialogTableVisible">
          <el-table :data="channel"  v-loading="loading" element-loading-text="加载中" border="true">
            <!--el-table-column property="channel" label="子渠道"></el-table-column-->
            <el-table-column property="url" label="监控连接"></el-table-column>
            <!--el-table-column property="apk" label="包连接"></el-table-column-->
            <el-table-column property="loadUrl" label="落地页"></el-table-column>
          </el-table>
        </el-dialog>


      <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <el-container>
        <el-divider content-position="center">监控连接</el-divider>
          <el-form-item label="是否生成监控连接:" style="text-align:left;padding:  0px 230px;">
                <el-switch v-model="isListener"  active-text="是" active-color="#13ce66" inactive-text="否">  
                </el-switch>
          </el-form-item>
          <el-header>
              <el-form-item label="生成数量:">
                <el-select v-model="size" :disabled='!isListener' filterable placeholder="请选择">
                  <el-option
                    v-for="s in 60"
                    :key="s"
                    :label="s"
                    :value="s">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="游戏:">
                <el-select v-model="gameId" :disabled='!isListener' filterable placeholder="请选择">
                  <el-option
                    v-for="item in games"
                    :key="item.id"
                    :label="item.gameName"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="SDK渠道:">
                <el-select v-model="sdkId"  :disabled='!isListener' filterable placeholder="请选择">
                  <el-option
                    v-for="item in sdks"
                    :key="item.id"
                    :label="item.sdkChannelName"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="市场渠道:">
                <el-select v-model="marketId" :disabled='!isListener' filterable placeholder="请选择">
                  <el-option
                    v-for="item in markets"
                    :key="item.id"
                    :label="item.marketChannelName"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-button plain @click="createPage">立即创建</el-button>
          </el-header>
          <el-divider content-position="center">包</el-divider>
          <el-header>
             <el-form-item label="是否生成APK:"  :label-position="labelPosition">
                <el-switch v-model="isApk"  active-text="是" active-color="#13ce66" inactive-text="否">  
                </el-switch>
              </el-form-item>
              <el-form-item label="母包:">
                <el-select v-model="apkId" filterable :disabled='!isApk' placeholder="请选择">
                  <el-option
                    v-for="item in apks"
                    :key="item.id"
                    :label="item.apkNickName"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
          </el-header>
          <el-divider content-position="center">落地页模板</el-divider>
          <el-form-item label="是否生成落地页:" style="text-align:left;padding:  0px 230px;">
                <el-switch v-model="isLoad"  active-text="是" active-color="#13ce66" inactive-text="否">  
                </el-switch>
          </el-form-item>

          <el-header style="width:70%; margin:0 auto" height="500px" v-if="isLoad">
            <el-carousel indicator-position ="none"  :autoplay = false  height="500px" type="card" ref="carousel" @change="templateChange">
              <el-carousel-item v-for="url in items" :key="url" style="text-align: -webkit-center;">
                <img style="height:499px" :src="url.template.url" />
              </el-carousel-item>
            </el-carousel>
          </el-header>

          <el-container v-for="(url, index) in items" :key="url">
         
            <el-container  v-show="templateIndex == index"  v-if="isLoad" style="padding-top:15px">
                
              <el-header style="text-align:center;">
                <el-form-item label="标题:">
                  <el-input v-model="indexTitle" placeholder="请输入标题" ></el-input>
                </el-form-item>
                <el-form-item label="公司:">
                  <el-input v-model="company" placeholder="请输入公司名称" ></el-input>
                </el-form-item>
                <el-form-item label="游戏下载地址:" v-show="!isApk && !isListener">
                  <el-input v-model="apkAddress"  placeholder="请输入包地址" ></el-input>
                </el-form-item>
                <el-form-item label="游戏:" v-show="!isApk && !isListener">
                  <el-input v-model="gameName"  placeholder="请输入游戏" ></el-input>
                </el-form-item>
              </el-header>
              <el-main  v-for="(img, index2)   in fileList" :key="img" style="border-bottom:1px solid #c0c4cc">
                <el-checkbox v-model="img.isLoad" border style="margin-bottom: 20px">图片是否为下载地址</el-checkbox>
                <el-upload
                  v-show="templateIndex == index"
                  :class="upload-demo"
                  :drag="false"
                  :action='tabPosition' 
                  :on-change="((file,fileList)=>{return onchange(file,fileList,index2)})"
                  :show-file-list="false">
                  <el-image :src="img.url"></el-image>
                </el-upload>
              </el-main>
            </el-container>
          </el-container>
        </el-container>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="信息" name="other">

          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="日志记录信息" name="first">

            <div style="text-align: left;padding-left:40px">
              <el-form :inline="true" :model="formInline" class="demo-form-inline">
                <el-form-item label="时间:">
                  <el-date-picker
                    v-model="pageChannel.startDate"
                    type="date"
                    placeholder=""
                    value-format="yyyy-MM-dd">
                  </el-date-picker>
                  ~
                  <el-date-picker
                    v-model="pageChannel.endDate"
                    type="date"
                    placeholder=""
                    value-format="yyyy-MM-dd">
                </el-date-picker>
                </el-form-item>
                <el-form-item label="游戏:">
                  <el-select v-model="pageChannel.gameId" filterable placeholder="请选择">
                    <el-option
                      v-for="item in games"
                      :key="item.id"
                      :label="item.gameName"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="市场渠道:">
                <el-select v-model="pageChannel.marketId" filterable placeholder="请选择">
                    <el-option
                      v-for="item in markets"
                      :key="item.id"
                      :label="item.marketChannelName"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
                 <el-button plain @click="msg" icon="el-icon-search">搜索</el-button>
                  <el-button plain @click="updateApkAddress" :disabled="multipleSelection == ''" >修改</el-button>
              </el-form>
              
            </div>




                <el-table
                  :data="msgs"
                  border
                  style="width: 100%"
                  @selection-change="handleSelectionChange"
                  :default-sort = "{prop: 'channel', order: 'descending'}">
                  
                  <el-table-column type="expand">
                    <template slot-scope="props">
                      <el-form label-position="left" inline class="demo-table-expand">
                        <el-form-item label="游戏名称">
                          <span>{{ props.row.gameName }}</span>
                        </el-form-item>
                        <el-form-item label="子渠道名称">
                          <span>{{ props.row.channel }}</span>
                        </el-form-item>
                        <el-form-item label="SDK渠道">
                          <span>{{ props.row.sdkName }}</span>
                        </el-form-item>
                        <el-form-item label="市场名称">
                          <span>{{ props.row.marketName }}</span>
                        </el-form-item>
                        <el-form-item label="apk地址">
                          <span>{{ props.row.apkUrl }}</span>
                          <el-button icon="el-icon-edit" type="primary" size="mini" @click="handleEdit(props.row)">修改</el-button>
                        </el-form-item>
                        <el-form-item label="落地页地址">
                          <span>{{ props.row.loadUrl }}</span>
                          <el-button icon="el-icon-edit" type="primary" size="mini" @click="handleEdit(props.row)">修改</el-button>
                        </el-form-item>
                        <el-form-item label="监控连接">
                          <span>{{ props.row.listenerUrl }}</span>
                        </el-form-item>
                      </el-form>
                    </template>
                  </el-table-column>

                  <el-table-column
                    type="selection"
                    width="55"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="gameName"
                    label="游戏名称"
                    width="120"
                   >
                  </el-table-column>
                    <el-table-column
                    prop="channel"
                    label="子渠道"
                    width="180"
                   >
                    <template  slot="header" slot-scope="scope">
                      子渠道
                      <el-button size="mini"  v-clipboard:copy="oneA" @click="addCopyMsg" round>点击复制</el-button>
                    </template>
                   </el-table-column>
                    <el-table-column
                    prop="sdkName"
                    label="SDK渠道"
                    width="120"
                   >
                  </el-table-column>
                  <el-table-column
                    prop="marketName"
                    label="市场名称"
                    width="120"
                   >
                  </el-table-column>
                  <el-table-column
                    prop="apkUrl"
                    label="apk地址">
                    <template slot="header" slot-scope="scope">
                      apk地址
                       <el-button size="mini"  v-clipboard:copy="oneB" @click="addCopyMsg1" round>点击复制</el-button>
                    </template>
                  </el-table-column>
                   <el-table-column
                    prop="loadUrl"
                    label="落地页地址">
                     <template slot="header" slot-scope="scope">
                      落地页地址
                      <el-button size="mini"  v-clipboard:copy="oneC" @click="addCopyMsg2" round>点击复制</el-button>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="listenerUrl"
                    label="监控连接">
                     <template slot="header" slot-scope="scope">
                      监控连接
                        <el-button size="mini"  v-clipboard:copy="oneD" @click="addCopyMsg3" round>点击复制</el-button>
                    </template>
                  </el-table-column>
                  
                  <!--el-table-column
                    fixed="right"
                    label="操作"
                    width="120">
                    <template slot-scope="scope">
                      <el-button
                        @click.native.prevent="handleEdit(scope.$index, scope.row)"
                        type="text"
                        size="small">
                        修改落地页
                      </el-button>
                    </template>
                  </el-table-column-->
                </el-table>
              <div style="text-align: left;padding-left:40px">
                <el-pagination
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="pageChannel.page"
                  :page-sizes="[15, 30, 50, 100]"
                  :page-size="pageChannel.size"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="pageChannel.total">
                </el-pagination>
              </div>
            </el-tab-pane>
            <el-tab-pane label="任务信息" name="second">
                 <el-table
                  :data="tasks"
                  border
                  style="width: 100%">
                  <el-table-column
                    prop="gameName"
                    label="游戏名称"
                   >
                  </el-table-column>
                    <el-table-column
                    prop="channel"
                    label="子渠道名称"
                   >
                  </el-table-column>
                  <el-table-column
                    prop="marketName"
                    label="市场名称"
                   >
                  </el-table-column>
                  <el-table-column
                    prop="apkUrl"
                    label="apk地址">
                  </el-table-column>
                   <el-table-column
                    prop="loadUrl"
                    label="落地页地址">
                  </el-table-column>
                  <el-table-column
                    prop="listenerUrl"
                    label="监控连接">
                  </el-table-column>
                </el-table>

            </el-tab-pane>
          </el-tabs>
      </el-tab-pane>
      
      <el-dialog
        :visible="dialogVisible"
        :before-close="handleClose"
        :show-close="false"
        :destroy-on-close = "true"
        center>

          <el-card class="box-card">
            <div v-for="(img, index)   in updateMsg.imgs" :key="img" class="text item" style="    text-align: center;border-bottom: 1px solid;padding: 20px">
                <el-checkbox v-model="img.isLoad" border style="margin-bottom: 20px">图片是否为下载地址</el-checkbox>
                <el-upload
                  :class="upload-demo"
                  :drag="false"
                  :action='tabPosition' 
                  :on-change="((file,fileList)=>{return onchange2(file,fileList,index)})"
                  :show-file-list="false">
                  <el-image :src="img.url"></el-image>
                </el-upload>
            </div>
          </el-card>
  
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="save()">确 定</el-button>
        </span>
      </el-dialog>
    </el-tabs>
    <div>
      <el-dialog
        title="母包地址"
        :visible.sync="dialogVisible2"
        width="30%"
        :before-close="handleClose">
        <span><el-select v-model="apkId" filterable  placeholder="请选择">
                  <el-option
                    v-for="item in apks"
                    :key="item.id"
                    :label="item.apkNickName"
                    :value="item.id">
                  </el-option>
                </el-select></span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible2 = false">取 消</el-button>
          <el-button type="primary" @click="updateApk" :disabled ='aaaaa' :icon ='aaaaa?"el-icon-loading":""'>{{aaaaaName}}</el-button>
        </span>
      </el-dialog>
    </div>
   </div>
 



</template>


<script>
export default {
  data() {
    return {
      oneA:'',
      oneB:'',
      oneC:'',
      oneD:'',
      dialogVisible: false,
      dialogVisible2:false,
      aaaaa:false,
      aaaaaName:"修改apk",
      tabPosition : 'left',
      items:[],
      games:[],
      sdks:[],
      markets:[],
      apks:[],
      tasks:[],
      msgs:[],
      loading2:true,
      type: 'page',
      templateIndex: 0,
      gameId :'',
      sdkId:'',
      company:'',
      marketId:'',
      apkId:'',
      size: 1,
      isApk : false,
      isLoad : false,
      isListener:false,
      fileList: [],
      indexTitle : '',
      dialogTableVisible:false,
      channel : [],
      loading:true,
      userId : '',
      xyToken:'',
      apkAddress:'',
      gameName:'',
      activeName: 'second',
      updateMsg :[],
      pageChannel:{
        startDate:this.getDate(new Date()).substring(0,10),
        endDate:this.getDate(new Date()).substring(0,10),
        gameId:'',
        marketId:'',
        page:1,
        size:15,
        total:15,
      },
      multipleSelection:[],
    }
  },
  mounted() {
    if(this.userId == ''){
      this.xyToken = this.$route.query.id;
    }
    this.view(); 
  },
  methods:{
      handleSelectionChange(val) {
        var channels = [];
        val.forEach(function(e){
          channels.push(e.channel);
        });
        this.multipleSelection = channels;
      },
      updateApkAddress(){
        this.dialogVisible2 =true
      },
      updateApk(){
        this.aaaaa=true;
        this.aaaaaName='修改APK中';
        var par = {"apkId":this.apkId,"channels":JSON.stringify(this.multipleSelection)};
        this.tajax.post("/api/updateApk",this.$qs.stringify(par),{headers:{"xianyu":this.xyToken}})
        .then((res)=>{
          this.$message('修改成功');
          this.dialogVisible2 = false;
          this.aaaaa=false;
          this.aaaaaName="修改apk";
        }).catch(err=>{

        });
      },
      //
      handleSizeChange(val) {
        this.pageChannel.size = val ;
        this.msg();
      },
      handleCurrentChange(val) {
        this.pageChannel.page = val;
        this.msg();
      },
    addCopyMsg(){
      var a1 = null;
      this.msgs.forEach(
        function(e){
          if(a1 == null){
            a1= e.channel;
          }else{
            a1 = e.channel + "\n" + a1  ;
          }
        }
      );
      this.oneA = a1;
      this.$notify({
          title: '成功',
          message: '复制成功',
          type: 'success',
          duration:1500,
          
      });
    },
    addCopyMsg1(){             
      var a1 = null;
      this.msgs.forEach(
        function(e){
          if(a1 == null){
            a1= e.apkUrl;
          }else{
            a1 =  e.apkUrl  + "\n" + a1;
          }
        }
      );
      this.oneB = a1;
      this.$notify({
          title: '成功',
          message: '复制成功',
          type: 'success',
          duration:1500,
          
      });
    },
    addCopyMsg2(){
      var a1 = null;
      this.msgs.forEach(
        function(e){
          if(a1 == null){
            a1= e.loadUrl;
          }else{
            a1 =  e.loadUrl + "\n"+ a1  ;
          }
        }
      );
      this.oneC = a1;
      this.$notify({
          title: '成功',
          message: '复制成功',
          type: 'success',
          duration:1500,
          
      });
    },
    addCopyMsg3(){
      var a1 = null;
      this.msgs.forEach(
        function(e){
          if(a1 == null){
            a1= e.listenerUrl;
          }else{
            a1 = e.listenerUrl + "\n" + a1 ;
          }
        }
      );
      this.oneD = a1;
      this.$notify({
          title: '成功',
          message: '复制成功',
          type: 'success',
          duration:1500,
          
      });
    },
     //当上传图片后，调用onchange方法，获取图片本地路径
    onchange2(file,fileList,index){
      debugger
      const self = this
      let reader = new FileReader()
      var _this = this;
      reader.onload  = function(event){
            let img_base64 = this.result
            let newFile = {"name":_this.updateMsg.imgs[index].name,"url":img_base64,"type":_this.updateMsg.imgs[index].type}
            _this.updateMsg.imgs.splice(index,1,newFile);
      }
      reader.readAsDataURL(file.raw)
    },
    save(){
      let par  = {"msg":JSON.stringify(this.updateMsg)}
      this.tajax.post("/api/update",this.$qs.stringify(par),{headers:{"xianyu":this.xyToken}})
      .then((res)=>{
        this.$message('修改成功');
        this.dialogVisible = false;
      }).catch(err=>{

      });
    },
    handleEdit(msg) {
      this.updateMsg = msg;
      this.dialogVisible = true;
    },
    handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            this.updateMsg = [];
            this.dialogVisible = false;
            done();
          })
          .catch(_ => {});
    },
    //模板
    view (){
      this.tajax.get("/api/find",{headers:{"xianyu":this.xyToken}})
      .then((res)=>{
        if(res.data.code == 0){
          this.items = res.data.data;
          this.xyToken = res.data.token;
          this.apkMsg();
          this.gameMsg();
          this.sdkChannelMsg()
          this.marketChannnelMsg();
          
          
        }else{
          alert("?????????");
        }
      }).catch(err=>{
       
      });
    },
    //游戏
    handleClick(tab, event) {
      if(this.activeName == 'second'){
          this.taskMsg();
      }else{
          this.msg();
      }
    },
    gameMsg (){
      this.tajax.get("/api/game",{headers:{"xianyu":this.xyToken}})
      .then((res)=>{
        this.games = res.data;
      }).catch(err=>{
       
      });
    },
    apkMsg(){
      this.tajax.get("/api/apk",{headers:{"xianyu":this.xyToken}})
      .then((res)=>{
        this.apks = res.data;
      }).catch(err=>{
       
      });
    },
    //SDK渠道
    sdkChannelMsg (){
      this.tajax.get("/api/cid",{headers:{"xianyu":this.xyToken}})
      .then((res)=>{
        this.sdks = res.data;
      }).catch(err=>{
       
      });
    },
    //市场渠道
    marketChannnelMsg (){
       this.tajax.get("/api/market",{headers:{"xianyu":this.xyToken}})
      .then((res)=>{
        this.markets = res.data;
      }).catch(err=>{
       
      });
    },
    taskMsg (){
       this.tajax.get("/api/task",{headers:{"xianyu":this.xyToken}})
      .then((res)=>{
        this.tasks = res.data;
      }).catch(err=>{
       
      });
    },
    msg (){ 
      this.tajax.post("/api/msg",this.$qs.stringify(this.pageChannel),{headers:{"xianyu":this.xyToken}})
      .then((res)=>{
        this.msgs = res.data.data;
        this.pageChannel.page = res.data.page;
        this.pageChannel.size = res.data.size;
        this.pageChannel.total = res.data.total;
      }).catch(err=>{
       
      });
    },
    //标题名称
    titleName (index){
      this.indexTitle = this.items[index].title;
      this.templateName = this.items[index].template.name;
      this.fileList =  this.items[index].template.imgs;
    },
    //切换
    templateChange(){
        let activeIndex = this.$refs.carousel.activeIndex;
        this.templateIndex = activeIndex;
        this.titleName(activeIndex);
    } ,
    //当上传图片后，调用onchange方法，获取图片本地路径
    onchange(file,fileList,index){
      const self = this
      let reader = new FileReader()
      var _this = this;
      reader.onload  = function(event){
            let img_base64 = this.result
            let newFile = {"name":_this.fileList[index].name,"url":img_base64,"type":_this.fileList[index].type}
            _this.fileList.splice(index,1,newFile);
      }
      reader.readAsDataURL(file.raw)
    },
    createPage(){
      this.dialogTableVisible=true;
      this.loading = true;
      this.channel= '';
      let par ={'gameName':this.gameName,'apkAddress':this.apkAddress,'isListener':this.isListener,'company':this.company,'apkId':this.apkId,'isApk':this.isApk,'isLoad':this.isLoad,'size':this.size,'gameId':this.gameId,'cid':this.sdkId,'marketId':this.marketId,'title':this.indexTitle,'templateName':this.templateName,'imgs':JSON.stringify(this.fileList)};
      this.tajax.post("/api/create",par,{headers:{"xianyu":this.xyToken,'Content-Type':'application/json'}})
      .then((res)=>{
        this.loading = false;
        this.channel = res.data;
      }).catch(err=>{

      });
    },
    dateFormat(row, column, cellValue, index){
        var date = new Date(row[column.property]);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
         return this.getDate(date)
    },
    getDate(date){
        var Y = date.getFullYear() + '-';
        var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
        var D = (date.getDate() < 10 ? '0'+date.getDate() : date.getDate()) + ' ';
        var h = (date.getHours() < 10 ? '0'+date.getHours() : date.getHours()) + ':';
        var m = (date.getMinutes() < 10 ? '0'+date.getMinutes() : date.getMinutes()) + ':';
        var s = (date.getSeconds() < 10 ? '0'+date.getSeconds() : date.getSeconds());
        return Y+M+D+h+m+s;      
    },
  }
}
</script>
<style>
  .el-main{
    text-align: center;
  }
  .el-header{
    text-align:left;
    padding:  0px 230px;
  }
    .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
</style>



// WEBPACK FOOTER //
// src/sem/page.vue